export const apiEndpoints = {
  'Activity Ethiccraft': 'https://ethiccraft.org/backend/activity_ethiccraft/read.php',
  'Activity Hexagon': 'https://ethiccraft.org/backend/activity_hexagon/read.php',
  'Activity Tiles': 'https://ethiccraft.org/backend/activity_tiles/read.php',
  'Alumni Ethiccraft': 'https://ethiccraft.org/backend/alumni_ethiccraft/read.php',
  'Blog': 'https://ethiccraft.org/backend/blog/read.php',
  'CA Queries': 'https://ethiccraft.org/backend/ca_queries/read.php',
  'Camp Ethiccraft': 'https://ethiccraft.org/backend/camp_ethiccraft/read.php',
  'Camp Highlights': 'https://ethiccraft.org/backend/camp_highlights/read.php',
  'Camp Memories': 'https://ethiccraft.org/backend/camp_memories/read.php',
  'Camp Reviews': 'https://ethiccraft.org/backend/camp_reviews/read.php',
  'Campus Ambassador': 'https://ethiccraft.org/backend/campus_ambassador/read.php',
  'Certificates': 'https://ethiccraft.org/backend/certificates/read.php',
  'Chapter Ethiccraft': 'https://ethiccraft.org/backend/chapter_ethiccraft/read.php',
  'College Chapters': 'https://ethiccraft.org/backend/college_chapters/read.php',
  'College Ethiccraft': 'https://ethiccraft.org/backend/college_ethiccraft/read.php',
  'College Events': 'https://ethiccraft.org/backend/college_events/read.php',
  'Event Bookings': 'https://ethiccraft.org/backend/event_bookings/read.php',
  'Events': 'https://ethiccraft.org/backend/events/read.php',
  'Excellence': 'https://ethiccraft.org/backend/excellence/read.php',
  'Explore': 'https://ethiccraft.org/backend/explore/read.php',
  'Faculty': 'https://ethiccraft.org/backend/faculty/read.php',
  'Gallery': 'https://ethiccraft.org/backend/gallery/read.php',
  'Latest Stories': 'https://ethiccraft.org/backend/latest_stories/read.php',
  'Product': 'https://ethiccraft.org/backend/product/read.php',
  'Reports': 'https://ethiccraft.org/backend/reports/read.php',
  'Team': 'https://ethiccraft.org/backend/team/read.php',
  'Upcoming Events': 'https://ethiccraft.org/backend/upcoming_events/read.php',
  'User Profiles': 'https://ethiccraft.org/backend/profile/read.php',
  'Valumni': 'https://ethiccraft.org/backend/valumni/read.php'
};

export const toggleEndpoints = {
  'Activity Ethiccraft': 'https://ethiccraft.org/backend/activity_ethiccraft/toggleShown.php',
  'Activity Hexagon': 'https://ethiccraft.org/backend/activity_hexagon/toggleShown.php',
  'Activity Tiles': 'https://ethiccraft.org/backend/activity_tiles/toggleShown.php',
  'Alumni Ethiccraft': 'https://ethiccraft.org/backend/alumni_ethiccraft/toggleShown.php',
  'Blog': 'https://ethiccraft.org/backend/blog/toggleShown.php',
  'CA Queries': 'https://ethiccraft.org/backend/ca_queries/toggleShown.php',
  'Camp Ethiccraft': 'https://ethiccraft.org/backend/camp_ethiccraft/toggleShown.php',
  'Camp Highlights': 'https://ethiccraft.org/backend/camp_highlights/toggleShown.php',
  'Camp Memories': 'https://ethiccraft.org/backend/camp_memories/toggleShown.php',
  'Camp Reviews': 'https://ethiccraft.org/backend/camp_reviews/toggleShown.php',
  // 'Campus Ambassador': 'https://ethiccraft.org/backend/campus_ambassador/toggleShown.php',
  'Certificates': 'https://ethiccraft.org/backend/certificates/toggleShown.php',
  'Chapter Ethiccraft': 'https://ethiccraft.org/backend/chapter_ethiccraft/toggleShown.php',
  'College Chapters': 'https://ethiccraft.org/backend/college_chapters/toggleShown.php',
  'College Ethiccraft': 'https://ethiccraft.org/backend/college_ethiccraft/toggleShown.php',
  'College Events': 'https://ethiccraft.org/backend/college_events/toggleShown.php',
  // 'Event Bookings': 'https://ethiccraft.org/backend/event_bookings/toggleShown.php',
  'Events': 'https://ethiccraft.org/backend/events/toggleShown.php',
  'Excellence': 'https://ethiccraft.org/backend/excellence/toggleShown.php',
  'Explore': 'https://ethiccraft.org/backend/explore/toggleShown.php',
  'Faculty': 'https://ethiccraft.org/backend/faculty/toggleShown.php',
  'Gallery': 'https://ethiccraft.org/backend/gallery/toggleShown.php',
  'Latest Stories': 'https://ethiccraft.org/backend/latest_stories/toggleShown.php',
  'Product': 'https://ethiccraft.org/backend/product/toggleShown.php',
  'Reports': 'https://ethiccraft.org/backend/reports/toggleShown.php',
  'Team': 'https://ethiccraft.org/backend/team/toggleShown.php',
  'Upcoming Events': 'https://ethiccraft.org/backend/upcoming_events/toggleShown.php',
  // 'User Profiles': 'https://ethiccraft.org/backend/user_profiles/toggleShown.php',
  'Valumni': 'https://ethiccraft.org/backend/valumni/toggleShown.php'
};

export const updateEndpoints = {
  // 'Activity Ethiccraft': 'https://ethiccraft.org/backend/activity_ethiccraft/update_textfields.php',
  // 'Activity Hexagon': 'https://ethiccraft.org/backend/activity_hexagon/update_textfields.php',
  // 'Activity Tiles': 'https://ethiccraft.org/backend/activity_tiles/update_textfields.php',
  // 'Alumni Ethiccraft': 'https://ethiccraft.org/backend/alumni_ethiccraft/update_textfields.php',
  'Blog': 'https://ethiccraft.org/backend/blog/update_textfields.php',
  'CA Queries': 'https://ethiccraft.org/backend/ca_queries/update_textfields.php',
  // 'Camp Ethiccraft': 'https://ethiccraft.org/backend/camp_ethiccraft/update_textfields.php',
  // 'Camp Highlights': 'https://ethiccraft.org/backend/camp_highlights/update_textfields.php',
  'Camp Memories': 'https://ethiccraft.org/backend/camp_memories/update_textfields.php',
  'Camp Reviews': 'https://ethiccraft.org/backend/camp_reviews/update_textfields.php',
  // 'Campus Ambassador': 'https://ethiccraft.org/backend/campus_ambassador/update_textfields.php',
  'Certificates': 'https://ethiccraft.org/backend/certificates/update_textfields.php',
  // 'Chapter Ethiccraft': 'https://ethiccraft.org/backend/chapter_ethiccraft/update_textfields.php',
  'College Chapters': 'https://ethiccraft.org/backend/college_chapters/update_textfields.php',
  'College Ethiccraft': 'https://ethiccraft.org/backend/college_ethiccraft/update_textfields.php',
  'College Events': 'https://ethiccraft.org/backend/college_events/update_textfields.php',
  // 'Event Bookings': 'https://ethiccraft.org/backend/event_bookings/update_textfields.php',
  'Events': 'https://ethiccraft.org/backend/events/update_textfields.php',
  // 'Excellence': 'https://ethiccraft.org/backend/excellence/update_textfields.php',
  'Explore': 'https://ethiccraft.org/backend/explore/update_textfields.php',
  'Faculty': 'https://ethiccraft.org/backend/faculty/update_textfields.php',
  // 'Gallery': 'https://ethiccraft.org/backend/gallery/update_textfields.php',
  'Latest Stories': 'https://ethiccraft.org/backend/latest_stories/update_textfields.php',
  'Product': 'https://ethiccraft.org/backend/product/update_textfields.php',
  'Reports': 'https://ethiccraft.org/backend/reports/update_textfields.php',
  'Team': 'https://ethiccraft.org/backend/team/update_textfields.php',
  'Upcoming Events': 'https://ethiccraft.org/backend/upcoming_events/update_textfields.php',
  // 'User Profiles': 'https://ethiccraft.org/backend/user_profiles/update_textfields.php',
  'Valumni': 'https://ethiccraft.org/backend/valumni/update_textfields.php'
};

export const updateImageEndpoints = {
  'Activity Ethiccraft': 'https://ethiccraft.org/backend/activity_ethiccraft/update_images.php',
  'Activity Hexagon': 'https://ethiccraft.org/backend/activity_hexagon/update_images.php',
  'Activity Tiles': 'https://ethiccraft.org/backend/activity_tiles/update_images.php',
  'Alumni Ethiccraft': 'https://ethiccraft.org/backend/alumni_ethiccraft/update_images.php',
  'Blog': 'https://ethiccraft.org/backend/blog/update_images.php',
  'CA Queries': 'https://ethiccraft.org/backend/ca_queries/update_images.php',
  'Camp Ethiccraft': 'https://ethiccraft.org/backend/camp_ethiccraft/update_images.php',
  'Camp Highlights': 'https://ethiccraft.org/backend/camp_highlights/update_images.php',
  'Camp Memories': 'https://ethiccraft.org/backend/camp_memories/update_images.php',
  'Camp Reviews': 'https://ethiccraft.org/backend/camp_reviews/update_images.php',
  // 'Campus Ambassador': 'https://ethiccraft.org/backend/campus_ambassador/update_images.php',
  // 'Certificates': 'https://ethiccraft.org/backend/certificates/update_images.php',
  'Chapter Ethiccraft': 'https://ethiccraft.org/backend/chapter_ethiccraft/update_images.php',
  'College Chapters': 'https://ethiccraft.org/backend/college_chapters/update_images.php',
  'College Ethiccraft': 'https://ethiccraft.org/backend/college_ethiccraft/update_images.php',
  'College Events': 'https://ethiccraft.org/backend/college_events/update_images.php',
  // 'Event Bookings': 'https://ethiccraft.org/backend/event_bookings/update_images.php',
  'Events': 'https://ethiccraft.org/backend/events/update_images.php',
  'Excellence': 'https://ethiccraft.org/backend/excellence/update_images.php',
  'Explore': 'https://ethiccraft.org/backend/explore/update_images.php',
  'Faculty': 'https://ethiccraft.org/backend/faculty/update_images.php',
  'Gallery': 'https://ethiccraft.org/backend/gallery/update_images.php',
  'Latest Stories': 'https://ethiccraft.org/backend/latest_stories/update_images.php',
  'Product': 'https://ethiccraft.org/backend/product/update_images.php',
  // 'Reports': 'https://ethiccraft.org/backend/reports/update_images.php',
  'Team': 'https://ethiccraft.org/backend/team/update_images.php',
  'Upcoming Events': 'https://ethiccraft.org/backend/upcoming_events/update_images.php',
  // 'User Profiles': 'https://ethiccraft.org/backend/user_profiles/update_images.php',
  'Valumni': 'https://ethiccraft.org/backend/valumni/update_images.php'
};

export const uploadEndpoints = {
  'Activity Ethiccraft': 'https://ethiccraft.org/backend/activity_ethiccraft/upload.php',
  'Activity Hexagon': 'https://ethiccraft.org/backend/activity_hexagon/upload.php',
  'Activity Tiles': 'https://ethiccraft.org/backend/activity_tiles/upload.php',
  'Alumni Ethiccraft': 'https://ethiccraft.org/backend/alumni_ethiccraft/upload.php',
  'Blog': 'https://ethiccraft.org/backend/blog/upload.php',
  'CA Queries': 'https://ethiccraft.org/backend/ca_queries/upload.php',
  'Camp Ethiccraft': 'https://ethiccraft.org/backend/camp_ethiccraft/upload.php',
  'Camp Highlights': 'https://ethiccraft.org/backend/camp_highlights/upload.php',
  'Camp Memories': 'https://ethiccraft.org/backend/camp_memories/upload.php',
  'Camp Reviews': 'https://ethiccraft.org/backend/camp_reviews/upload.php',
  // 'Campus Ambassador': 'https://ethiccraft.org/backend/campus_ambassador/upload.php',
  'Certificates': 'https://ethiccraft.org/backend/certificates/upload_cert_zip.php',
  'Chapter Ethiccraft': 'https://ethiccraft.org/backend/chapter_ethiccraft/upload.php',
  'College Chapters': 'https://ethiccraft.org/backend/college_chapters/upload.php',
  'College Ethiccraft': 'https://ethiccraft.org/backend/college_ethiccraft/upload.php',
  'College Events': 'https://ethiccraft.org/backend/college_events/upload.php',
  // 'Event Bookings': 'https://ethiccraft.org/backend/event_bookings/upload.php',
  'Events': 'https://ethiccraft.org/backend/events/upload.php',
  'Excellence': 'https://ethiccraft.org/backend/excellence/upload.php',
  'Explore': 'https://ethiccraft.org/backend/explore/upload.php',
  'Faculty': 'https://ethiccraft.org/backend/faculty/upload.php',
  'Gallery': 'https://ethiccraft.org/backend/gallery/upload.php',
  'Latest Stories': 'https://ethiccraft.org/backend/latest_stories/upload.php',
  'Product': 'https://ethiccraft.org/backend/product/upload.php',
  'Reports': 'https://ethiccraft.org/backend/reports/upload.php',
  'Team': 'https://ethiccraft.org/backend/team/upload.php',
  'Upcoming Events': 'https://ethiccraft.org/backend/upcoming_events/upload.php',
  // 'User Profiles': 'https://ethiccraft.org/backend/user_profiles/upload.php',
  'Valumni': 'https://ethiccraft.org/backend/valumni/upload.php'
};

export const formsData = [
  {
    name: 'Activity Ethiccraft',
    description: 'Displays four key visuals as the leading section under the Activities tab, representing core Ethiccraft initiatives.'
  },
  {
    name: 'Activity Hexagon',
    description: 'Titled "Frames of Change", this section features image-based content under the Activities tab.'
  },
  {
    name: 'Activity Tiles',
    description: 'Showcases the "Lead – Serve – Transform" theme through visual tiles in the Activities tab.'
  },
  {
    name: 'Alumni Ethiccraft',
    description: 'Highlights our alumni network with a single featured image, located in the Valumni tab.'
  },
  {
    name: 'Blog',
    description: 'Publishes blog content under the “Voice of Ethiccraft” series, accessible from the Activities tab.'
  },
  {
    name: 'CA Queries',
    description: 'Displays frequently asked questions from students regarding the Campus Ambassador program in a slider format.'
  },
  {
    name: 'Camp Ethiccraft',
    description: 'Features a visual slider at the top of the Camps tab, presenting details of various Ethiccraft-organized camps.'
  },
  {
    name: 'Camp Highlights',
    description: 'An image slider within the Camps tab showcasing key moments from past Ethiccraft camps and tours.'
  },
  {
    name: 'Camp Memories',
    description: 'Presents a visual gallery of memories and moments captured during past Ethiccraft camps.'
  },
  {
    name: 'Camp Reviews',
    description: 'Displays testimonials and feedback from students who have attended Ethiccraft camps, featured in the Camps tab.'
  },
  {
    name: 'Campus Ambassador',
    description: 'Captures data from students applying to join the Campus Ambassador program through the Join Team form.'
  },
  {
    name: 'Certificates',
    description: 'Stores and manages digital certificates issued to participants across Ethiccraft events and activities.'
  },
  {
    name: 'Chapter Ethiccraft',
    description: 'Showcases Ethiccraft chapter teams across colleges through a visual section in the Chapters tab.'
  },
  {
    name: 'College Chapters',
    description: 'Provides comprehensive profiles and listings of all colleges participating in the Ethiccraft chapter network.'
  },
  {
    name: 'College Ethiccraft',
    description: 'Displays the "About" section for a specific college within the Colleges tab.'
  },
  {
    name: 'College Events',
    description: 'Features recent events conducted at individual colleges, shown in the Colleges tab.'
  },
  {
    name: 'Event Bookings',
    description: 'Captures and stores registration data and participant responses for upcoming events.'
  },
  {
    name: 'Events',
    description: 'Highlights up to four recent events on the Home tab for general visitors.'
  },
  {
    name: 'Excellence',
    description: 'Showcases Ethiccraft’s awards, world records, and major accomplishments on the Home tab.'
  },
  {
    name: 'Explore',
    description: 'Curates images and highlights of Ethiccraft initiatives across various college chapters, presented in the Home tab.'
  },
  {
    name: 'Faculty',
    description: 'Displays detailed profiles of faculty members, including designations and affiliations, in the About tab.'
  },
  {
    name: 'Gallery',
    description: 'Hosts a visual gallery of Ethiccraft images featured within the About tab.'
  },
  {
    name: 'Latest Stories',
    description: 'Publishes recent chapter updates and milestone stories in the Chapters tab.'
  },
  {
    name: 'Product',
    description: 'Highlights a special featured fest with a customized design component on the Home tab.'
  },
  {
    name: 'Reports',
    description: 'Contains downloadable PDF reports documenting completed events and their impact.'
  },
  {
    name: 'Team',
    description: 'Displays detailed information on centralized and college-specific team members across the organization.'
  },
  {
    name: 'Upcoming Events',
    description: 'Comprehensive management of future events including banners, registration forms, questions, and configurations.'
  },
  {
    name: 'User Profiles',
    description: 'Maintains individual user data including contact details, education, and skills for authenticated members.'
  },
  {
    name: 'Valumni',
    description: 'Houses records of verified alumni from the Ethiccraft community, including bios and images.'
  }
];

export const defaultStructure = {
  'Activity Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Activity Hexagon': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Activity Tiles': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Alumni Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Blog': {
    name: '',
    description: '',
    image: '',
    author: '',
    date: '',
    isShown: '',
    created_at: ''
  },
  'Campus Ambassador': {
    full_name: '',
    email: '',
    phone_number: '',
    additional_message: '',
    college: '',
    portfolio: '',
    created_at: ''
  },
  'Camp Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Camp Highlights': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Camp Memories': {
    image: '',
    caption: '',
    isShown: '',
    created_at: ''
  },
  'Camp Reviews': {
    name: '',
    role: '',
    text: '',
    image: '',
    position: '',
    isShown: '',
    created_at: ''
  },
  'CA Queries': {
    query_no: '',
    title: '',
    description: '',
    image: '',
    created_at: '',
    isShown: ''
  },
  'Certificates': {
    user_id: '',
    event_id: '',
    certificate_path: '',
    isShown: '',
    created_at: ''
  },
  'Chapter Ethiccraft': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'College Chapters': {
    title: '',
    university_name: '',
    image: '',
    details: '',
    visit_url: '',
    isShown: '',
    created_at: ''
  },
  'College Ethiccraft': {
    image: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'College Events': {
    name: '',
    description: '',
    image: '',
    college: '',
    venue: '',
    date: '',
    isShown: '',
    created_at: ''
  },
  'Events': {
    name: '',
    description: '',
    date: '',
    venue: '',
    image: '',
    isShown: '',
    created_at: ''
  },
  // 'Event Bookings': {
  //   event_id: '',
  //   email: '',
  //   user_name: '',
  //   booking_time: '',
  //   answer1: '',
  //   answer2: '',
  //   answer3: '',
  //   answer4: '',
  //   answer5: '',
  //   answer6: '',
  //   answer7: '',
  //   answer8: '',
  //   answer9: '',
  //   answer10: '',
  //   answer11: '',
  //   answer12: '',
  //   answer13: '',
  //   answer14: '',
  //   answer15: '',
  //   answer16: '',
  //   answer17: '',
  //   answer18: '',
  //   answer19: '',
  //   answer20: '',
  //   answer21: '',
  //   answer22: '',
  //   answer23: '',
  //   answer24: '',
  //   answer25: '',
  //   answer26: '',
  //   answer27: '',
  //   answer28: '',
  //   answer29: '',
  //   answer30: ''
  // },
  'Excellence': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Explore': {
    image: '',
    isShown: '',
    created_at: '',
    title: '',
    venue: ''
  },
  'Faculty': {
    faculty_name: '',
    faculty_designation: '',
    faculty_image: '',
    faculty_description: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'Gallery': {
    image: '',
    isShown: '',
    created_at: ''
  },
  'Latest Stories': {
    title: '',
    college: '',
    date: '',
    description: '',
    image: '',
    isShown: '',
    created_at: ''
  },
  'Product': {
    name: '',
    description: '',
    date: '',
    venue: '',
    image: '',
    isShown: '',
    created_at: ''
  },
  'Reports': {
    report_date: '',
    event_name: '',
    pdf_link: '',
    area: '',
    isShown: '',
    created_at: ''
  },
  'Team': {
    name: '',
    designation: '',
    image: '',
    description: '',
    college: '',
    isShown: '',
    created_at: ''
  },
  'Upcoming Events': {
    name: '',
    description: '',
    date: '',
    venue: '',
    college: '',
    banner_image1: '',
    banner_image2: '',
    banner_image3: '',
    question1: '', question2: '', question3: '', question4: '', question5: '',
    question6: '', question7: '', question8: '', question9: '', question10: '',
    question11: '', question12: '', question13: '', question14: '', question15: '',
    question16: '', question17: '', question18: '', question19: '', question20: '',
    question21: '', question22: '', question23: '', question24: '', question25: '',
    question26: '', question27: '', question28: '', question29: '', question30: '',
    questionType1: '', questionType2: '', questionType3: '', questionType4: '', questionType5: '',
    questionType6: '', questionType7: '', questionType8: '', questionType9: '', questionType10: '',
    questionType11: '', questionType12: '', questionType13: '', questionType14: '', questionType15: '',
    questionType16: '', questionType17: '', questionType18: '', questionType19: '', questionType20: '',
    questionType21: '', questionType22: '', questionType23: '', questionType24: '', questionType25: '',
    questionType26: '', questionType27: '', questionType28: '', questionType29: '', questionType30: '',
    option1: '', option2: '', option3: '',
    whatsapp_link: '',
    qmand1: '', qmand2: '', qmand3: '', qmand4: '', qmand5: '',
    qmand6: '', qmand7: '', qmand8: '', qmand9: '', qmand10: '',
    qmand11: '', qmand12: '', qmand13: '', qmand14: '', qmand15: '',
    qmand16: '', qmand17: '', qmand18: '', qmand19: '', qmand20: '',
    qmand21: '', qmand22: '', qmand23: '', qmand24: '', qmand25: '',
    qmand26: '', qmand27: '', qmand28: '', qmand29: '', qmand30: '',
    isOpen: '',
    isShown: '',
    created_at: ''
  },
  // 'User Profiles': {
  //   user_id: '',
  //   full_name: '',
  //   email: '',
  //   phone_number: '',
  //   profile_image: '',
  //   gender: '',
  //   dob: '',
  //   blood_group: '',
  //   bio: '',
  //   college: '',
  //   department: '',
  //   year_of_study: '',
  //   skills: '',
  //   address: '',
  //   social_links: '',
  //   isShown: '',
  //   created_at: '',
  //   updated_at: ''
  // },
  'Valumni': {
    image: '',
    name: '',
    description: '',
    tags: '',
    isShown: '',
    created_at: ''
  }
};